module.exports = {
    "crude": {
        "search": "Tražiti",
        "actions": "Radnje",
        "nextPage": "Sljedeća stranica",
        "lastPage": "Prethodna stranica",
        "back": "leđa",
        "empty": "prazan",
        "edit": "Uredi",
        "create": "stvoriti",
        "data": "snimiti",
        "view": "pokazati",
        "delete": "Izbrisati",
        "save": "Uštedjeti",
        "cancel": "Otkazati",
        "noContent": "Nema dostupnih unosa. ",
        "resetFilter": "Ponovno postavite filtre i pogledajte više sadržaja!",
        "createOwnTextField": "Stvorite vlastito tekstno polje",
        "textFieldName": "oznaka tekstualnog polja",
        "textFieldValue": "Sadržaj",
        "insertTextFieldLabel": "Unesite naziv tekstualnog polja!",
        "deleteTextField": "Brisanje tekstualnog polja",
        "success": "Spremanje je bilo uspješno",
        "invalidDataFields": "Sljedeća podatkovna polja su nevažeća:  ",
        "entries": "unose",
        "entry": "unos",
        "tabDetail": "pojedinosti",
        "entity": "entitet",
        "of": "iz",
        "uploadNewFile": "Učitaj datoteku",
        "upload": "Učitaj",
        "confirm": "u redu",
        "deleteFileQuestion": "Želite li stvarno izbrisati ovu datoteku? ",
        "deleteFileQuestionTitle": "Opasnost!",
        "deleteEntityQuestion": "Želite li stvarno izbrisati ovaj entitet? ",
        "deleteEntityQuestionTitle": "Opasnost!",
        "errorLargeFileUpload": "Odabrana datoteka je prevelika!",
        "useCroppedImage": "Koristite obrezivanje",
        "useOriginalImage": "Koristi originalnu sliku",
        "available": "dostupno",
        "searchColumn": "pronaći stupac",
        "manageColumns": "Upravljanje stupcima",
        "hideColumn": "sakrij stupac",
        "pinToRight": "Prikvači stupac s desne strane",
        "pinToLeft": "Prikvači stupac lijevo",
        "sortAsc": "Poredaj uzlazno",
        "sortDesc": "Poredaj silazno",
        "hideAll": "sakriti sve",
        "showAll": "Pokaži sve",
        "preview": "pretpregled",
        "title": "titula",
        "description": "Opis",
        "tooltip": "opis alata",
        "sort": "poredati po",
        "settings": "postavke",
        "incomingReference": "referenca",
        "language": "Jezik",
        "deleteTabQuestionTitle": "Opasnost!",
        "deleteTabQuestion": "Želite li stvarno izbrisati ovu karticu? ",
        "deleteElementQuestionTitle": "Opasnost!",
        "deleteElementQuestion": "Želite li stvarno izbrisati ovu stavku? ",
        "configurationEditorDescriptionStringLayout": "U ovoj koloni mogu se odabrati tri varijante za unos teksta:",
        "configurationEditorDescriptionEnumLayout": "Za odabir elemenata u ovom stupcu mogu se odabrati dvije varijante:",
        "configurationEditorDescriptionBooleanLayout": "Za odabir elemenata u ovom stupcu mogu se odabrati dvije varijante:",
        "configurationEditorDescriptionForeignEntityLayout": "Za odabir elemenata u ovom stupcu mogu se odabrati dvije varijante:",
        "stringLayoutsingleline": "jedna linija",
        "stringLayoutmultiline": "višelinijski",
        "stringLayouteditor": "Uređivač obogaćenog teksta",
        "enumLayoutradio": "Radio gumb",
        "enumLayoutdropdown": "padajući izbornik",
        "booleanLayoutcheckbox": "potvrdni okvir",
        "booleanLayoutswitch": "sklopke",
        "foreignEntityLayoutpopUp": "iskočiti",
        "foreignEntityLayoutautocomplete": "padajući izbornik",
        "foreignEntityLayoutlist": "popis",
        "formatTooltipbold": "Mast",
        "formatTooltipitalic": "kurziv",
        "formatTooltipunderline": "podcrtano",
        "formatTooltipstrike": "Prekrižen",
        "formatTooltipclean": "jasno oblikovanje",
        "formatTooltipcodeBlock": "kodirati",
        "formatTooltipblockquote": "Citat",
        "formatTooltipcolor": "boja fonta",
        "formatTooltipbackground": "boja pozadine",
        "formatTooltipfont": "font",
        "formatTooltipalign": "poravnanje",
        "formatTooltipheader": "veličina fonta",
        "formatTooltipsuper": "Superskript",
        "formatTooltipsub": "indeks",
        "formatTooltipordered": "Naručena lista",
        "formatTooltipbullet": "Nabrajanje",
        "true": "Da",
        "false": "Ne",
        "selectEntity": "odaberite entitet",
        "filter": "filtar",
        "useFilter": "Primijeni filtre",
        "defaultFilter": "resetirati filter",
        "expand": "proširiti",
        "hide": "sakriti",
        "minimumSelectionError": "Najmanje {{min}} unosa mora biti odabrano.",
        "maximumSelectionError": "Može se odabrati najviše {{max}} unosa."
    }
}
;